import { Routes } from '@angular/router';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'atx-card',
    template: `<div class="card {{ clazz }}"
     [class.border-0]="!hasBorder">
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'info'">
            <div class="card-body">
                <h5 class="card-title">
                    {{ model?.title }}
                </h5>
                <h6 class="card-subtitle mb-2 text-muted">
                    {{ model?.subtitle }}
                </h6>
                <p class="card-text"
                   [innerHTML]="model?.text">
                </p>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'image'">
            <img class="card-img-top"
                 [src]="model?.image?.src"
                 [alt]="model?.image?.alt">
            <div class="card-body"
                 *ngIf="model?.title || model?.text">
                <h5 class="card-title">{{ model?.title }}</h5>
                <p class="card-text"
                   [innerHTML]="model?.text">
                </p>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'list'">
            <div class="card-body">
                <h3 class="card-title">
                    {{ model?.title }}
                </h3>
                <ng-container *ngTemplateOutlet="multiNgContent"></ng-container>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'box'">
            <div class="card-header">
                {{ model?.title }}
            </div>
            <div class="card-body">
                <ng-container *ngTemplateOutlet="multiNgContent"></ng-container>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'navigation'">
            <div class="card text-center">
                <div class="card-header">
                    <atx-router-tabs clazz="nav nav-tabs card-header-tabs"
                                     [count]="3"
                                     [path]="path"
                                     [routes]="routes">
                    </atx-router-tabs>
                </div>
                <div class="card-body text-{{ textAlign }}">
                    <div class="container">
                        <div class="row">
                            <ng-container *ngTemplateOutlet="multiNgContent"></ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #multiNgContent>
    <ng-content></ng-content>
</ng-template>
`,
    styles: [``],
})

export class AtxCardComponent {
    @Input() public readonly model;
    @Input() public readonly type: string;
    @Input() public readonly path: string;
    @Input() public readonly clazz: string;
    @Input() public readonly routes: Routes;
    @Input() public readonly hasBorder: boolean = true;
    @Input() public readonly textAlign: string = 'left';
}
